import { Button, Textarea } from '@cian/ui-kit';
import { IconActionArrowLeft16 } from '@cian/ui-kit-design-tokens/icons';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './styles.css';
import { useMessageInput, MAX_MESSAGE_LENGTH } from './useMessageInput';

type TMessageInputFieldProps = {
  chatId: string;
  leftButton: React.ReactNode | null;
  replyTemplateButton: React.ReactNode | null;
  hintQuestions: React.ReactNode | null;
  captcha?: React.ReactNode | null;
  isLoading: boolean;
  isInputDisabled: boolean;
  isSendButtonDisabled: boolean;
  onSend(params: { text: string; chatId: string; captchaToken?: string | null; payload?: string }): void;
  onHeightChange(): void;
  placeholder?: string;
  inputRef?: React.Ref<HTMLTextAreaElement>;
  replyQuote: React.ReactNode;
};

export const MessageInputField: React.FC<TMessageInputFieldProps> = ({
  chatId,
  captcha,
  leftButton,
  isLoading,
  isInputDisabled,
  isSendButtonDisabled,
  onSend,
  onHeightChange,
  hintQuestions,
  placeholder,
  replyTemplateButton,
  inputRef,
  replyQuote,
}) => {
  const { text, onKeyDown, onValueChange, onBlur, onFocus, trySend } = useMessageInput({
    chatId,
    isSendButtonDisabled,
    onSend,
    onHeightChange,
  });

  return (
    <div className={styles['container']} data-name="MessageInputField">
      {hintQuestions && <div className={styles['hint-questions']}>{hintQuestions}</div>}
      {replyQuote}
      <div className={styles['wrapper']}>
        {captcha && <div className={styles['captcha']}>{captcha}</div>}
        <div className={styles['inner-container']}>
          {leftButton}
          <Textarea
            value={text}
            onChange={onValueChange}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
            onFocus={onFocus}
            placeholder={placeholder || 'Написать сообщение'}
            disabled={isInputDisabled || isLoading}
            maxRows={10}
            minRows={1}
            maxLength={MAX_MESSAGE_LENGTH}
            size="M"
            data-name="MessageInputField_textarea"
            inputRef={inputRef}
          />
          {replyTemplateButton}
          <Button
            onClick={trySend}
            beforeIcon={isLoading ? undefined : <IconActionArrowLeft16 />}
            loading={isLoading}
            disabled={!text.trim().length || isLoading || isSendButtonDisabled}
            {...mergeStyles(
              styles['button-wrapper'],
              Boolean(text.trim().length && !isSendButtonDisabled) && styles['button-wrapper--active'],
            )}
            data-testid="send_button"
            data-name="MessageInputField_send_button"
          />
        </div>
      </div>
    </div>
  );
};
